<template>
    <div :key="componentKey">
        <vs-popup title="" 
            :button-close-hidden="true" 
            :active.sync="isActive"
            @close="$emit('isActiveFalse')"
            style="border-radius: 10px !important;"
            id="popUpPreOrderSummaryChat"
        >
            <div>
                <span id="display-span-orders">
                    <vs-icon @click="$emit('backToNotesAndFiles')" class="mr-2" icon="keyboard_arrow_left" style="border: solid 1px; border-radius: 14px; cursor: pointer;"/>
                    <p class="ml-2" style="font-size: 20px; width: 450px !important;">Resumo do Orçamento</p>
                    <div class="flex-end-align">
                        <vs-icon @click="closePopUp" class="mr-2" icon="close" style="-webkit-transform: scaleX(-1); transform: scaleX(-1); float: right;"></vs-icon>
                    </div>
                </span>
            </div>

            <div class="ml-12 mr-6 mt-6">
                <span>
                    <p class="inline" style="font-size: 18px;"> 
                    {{ 
                        chatContact ? chatContact.customer.name
                        : chatTicket.customer.name 
                    }} 
                    </p> 
                    <!--<feather-icon
                        icon="EditIcon"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current"  
                    />-->
                </span> <br>
                <span v-if="dataOfProductsToPreOrder.delivery !== 'none'">
                    <p v-if="dataOfProductsToPreOrder.delivery && dataOfProductsToPreOrder.delivery.typeOfDelivery == 'delivery'" class="text-9x inline"> {{ dataOfProductsToPreOrder.delivery.address }}, N° {{ dataOfProductsToPreOrder.delivery.number }} </p>
                    <p v-else-if="dataOfProductsToPreOrder.delivery && dataOfProductsToPreOrder.delivery.typeOfDelivery == 'not_delivery'" class="text-9x inline"> Pedido para retirada no Local </p>
                    <!--<<feather-icon
                        icon="EditIcon"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current"  
                    />-->
                </span>
            </div>

            <div class="ml-10 mr-6">
                <vs-tabs ref="tabOfPreOrderSummary" v-model="selectedTab">
                    <vs-tab :disabled="!dataOfProductsToPreOrder.product" label="Produtos" icon="shopping_basket" size="small">
                        <vs-table
                            v-if="dataOfProductsToPreOrder.product"
                            ref="table"
                            :data="dataOfProductsToPreOrder.product"
                            noDataText="Sem dados disponíveis"
                            id="tableProductPreOrdersSummaryChat"
                            style="padding: 0 !important;"
                            @sort="sortFilter"
                            :sst="true"
                        >
                            <template slot="thead">
                                <vs-th class="text-base">
                                    Imagem
                                </vs-th>
                                <vs-th class="text-base" sort-key="name">
                                    Nome
                                </vs-th>
                                <vs-th class="text-base" sort-key="price">
                                    Preço com Desconto
                                </vs-th>
                                <vs-th class="text-base" sort-key="price">
                                    Preço
                                </vs-th>
                                <vs-th class="text-base" sort-key="quantity">
                                    Quantidade
                                </vs-th>
                                <vs-th class="text-base" v-if="dataOfProductsToPreOrder.product.length > 1">
                                    Ações
                                </vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <tbody>
                                    <vs-tr
                                        :data="tr" 
                                        :key="tr.id"
                                        :id="tr.id"
                                        v-for="(tr, index) in dataOfProductsToPreOrder.product"
                                    > 
                                        <vs-td :data="tr.name">
                                            <div class="d-flex flex-row items-center justify-around">
                                                <img v-if="tr.image !== undefined && tr.image !== '' && tr.image != null" :src="tr.image" style="width: 50px !important; height: 50px !important;">
                                                <img v-else src="@/assets/images/products/product_without_photo.png" style="width: 40px !important; height: 40px !important;">
                                            </div>
                                        </vs-td>

                                        <vs-td :data="tr.name">
                                            <div class="d-flex flex-row items-center justify-around">
                                                <p class="text-center">
                                                    {{ tr.name }}
                                                </p>
                                            </div>
                                        </vs-td>

                                        <vs-td >
                                            <p class="text-center">
                                                <strong>R$ {{ String((parseFloat(tr.discount_price) * tr.quantity).toFixed(2)).replace('.', ',') }}</strong>
                                            </p>
                                        </vs-td>

                                        <vs-td :data="tr.price" style="border-top: 1px solid #b6bebd6e; border-bottom: 1px solid#b6bebd6e;">
                                            <p class="text-center">
                                                <strong>R$ {{ String((parseFloat(tr.price) * tr.quantity).toFixed(2)).replace('.', ',') }}</strong>
                                            </p>
                                        </vs-td>

                                        <vs-td :data="tr.amount" class="text-center">
                                            <div v-if="!enableNegativeStock && tr.integration_id !== null && tr.amount <= 0 && hasErpFeature">
                                                <vs-chip id="warn" color="warning">
                                                    <feather-icon @mouseenter="alertQty()" feather-icon icon="SlashIcon"></feather-icon>
                                                </vs-chip >
                                            </div>
                                            <p v-else class="text-center">
                                                Qtde <strong>
                                                        <span style="color: #1196e1; font-size: 16px;">{{ tr.quantity }}</span>
                                                    </strong>
                                            </p>
                                        </vs-td>

                                        <vs-td class="text-center" v-if="dataOfProductsToPreOrder.product.length > 1">
                                            <feather-icon
                                                class="trash" 
                                                icon="TrashIcon"
                                                svgClasses="w-5 h-5 ml-1 hover:text-danger stroke-current"
                                                @click.stop="removeProduct(index)"
                                            />

                                        </vs-td>

                                    </vs-tr>
                                </tbody>
                            </template>
                        </vs-table>
                    </vs-tab>

                    <vs-tab v-if="hasServicesFeature" :disabled="!hasService" label="Serviços" icon="build" size="small">
                        <vs-table
                            v-if="hasService"
                            ref="table" 
                            :data="services"
                            noDataText="Sem dados disponíveis"
                            id="tableServicePreOrdersSummaryChat"
                            style="padding: 0 !important;"
                        >
                            <template slot="thead">
                                <vs-th class="text-base">
                                    Nome
                                </vs-th>
                                <vs-th class="text-base">
                                    Preço
                                </vs-th>
                                <vs-th class="text-base">
                                    Preço Com Desconto
                                </vs-th>
                                <vs-th class="text-base">
                                    Data e Hora de Realização
                                </vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <tbody>
                                    <vs-tr 
                                        :data="tr" 
                                        :key="tr.id"
                                        :id="tr.id"
                                        v-for="(tr, index) in services"
                                        ref="trService"
                                    >
                                        <vs-td :data="tr.name">
                                            <p class="ml-4">
                                                {{ tr.name }}
                                            </p>
                                        </vs-td>

                                        <vs-td :data="tr.price">
                                            <p class="ml-4">
                                               <strong> R$ {{ String(parseFloat(tr.price).toFixed(2)).replace('.', ',') }} </strong>
                                            </p>
                                        </vs-td>

                                        <vs-td :data="tr.discount_price">
                                            <p class="ml-4">
                                               <strong> R$ {{ String(parseFloat(tr.discount_price).toFixed(2)).replace('.', ',') }} </strong>
                                               <feather-icon
                                                
                                                icon="EditIcon"
                                                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                                @click="openModalService(tr, index)"
                                                style="display: inline !important;"
                                            />
                                            </p>
                                        </vs-td>

                                        <vs-td :data="tr.id">
                                            <div class="align-input-date-time">
                                                <div class="ml-2">
                                                    <flat-pickr
                                                        :config="configDatePicker"
                                                        :placeholder="serviceDates[index] ? serviceDates[index] :'DD/MM/AAAA'"
                                                        v-model="serviceDates[index]"
                                                        class="w-full"
                                                        name="data"
                                                        style="width: 120px !important;"
                                                    />
                                                </div>
    
                                                <div class="ml-2">
                                                    <flat-pickr
                                                        class=" w-full"
                                                        name="hora"
                                                        v-model="serviceTimes[index]"
                                                        placeholder="HH:MM"
                                                        :config="configdateTimePicker"
                                                        style="width: 80px !important;"
                                                    />
                                                </div>
                                            </div>
                                        </vs-td>

                                        <div style="margin-top: 10px !important;">
                                            <feather-icon
                                                style="margin-top: 10px !important; margin-left: 6px !important;"
                                                icon="EditIcon"
                                                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                                @click="$emit('editProductsPreOrder')"
                                            />
                                        </div>
                                    </vs-tr>
                                </tbody>
                            </template>
                        </vs-table>
                    </vs-tab>

                    <vs-tab 
                    :disabled="files.length === 0 && !dataOfProductsToPreOrder.note" 
                    icon="description" 
                    size="small"
                    label="Arquivos e Observação"
                    >
                        <vs-table
                        ref="table" 
                        :data="files"
                        noDataText="Sem dados disponíveis"
                        id="tableServicePreOrdersSummaryChat"
                        style="padding: 0 !important;"
                        v-if="files.length > 0"
                        :pagination="files.length > 5"
                        >
                            <template slot="thead">
                                <vs-th class="text-base">
                                    Nome
                                </vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <tbody>
                                    <vs-tr 
                                        :data="tr" 
                                        :key="tr.id"
                                        :id="tr.id"
                                        v-for="(tr, index) in data"
                                    >
                                        <vs-td :data="tr.name">
                                            <p class="ml-4">
                                                {{ tr.name }}
                                            </p>
                                        </vs-td>

                                    </vs-tr>
                                </tbody>
                            </template>
                        </vs-table>

                        <div v-if="dataOfProductsToPreOrder.note" class="pl-3 mt-3 mb-2">
                            <strong>Observação:</strong> {{ dataOfProductsToPreOrder.note }}
                        </div>
                    </vs-tab>

                    <vs-tab
                     icon="import_contacts"
                     size="small"
                     label="Modelo de Dados ..."
                     title="Modelo de Dados do Cliente"
                     :disabled="!currentKnow"
                    >
                        <div v-if="currentKnow">
                            <vs-divider>
                                {{ currentKnow.description }}
                            </vs-divider>
                      
                            <vs-textarea
                              v-validate="'required'"
                              v-if="currentKnow.use_observation && currentKnow.require_observation"
                              name="observation" class="w-full" label="Observações" v-model="observation"
                              :required="currentKnow.require_observation"
                              :disabled="true"
                            ></vs-textarea>
                      
                            <vs-textarea
                              v-else-if="currentKnow.use_observation"
                              :required="currentKnow.require_observation"
                              name="observation" class="w-full" label="Observações" v-model="observation"
                              :disabled="true"
                            ></vs-textarea>
                    
                            <div class="clear"></div>
                            <div>
                                <component
                                    v-for="(option, index) in options"
                                    :description="currentKnow.reason_options[index].description"
                                    :items="responses[index]"
                                    :index="index"
                                    :key="index"
                                    :is="option"
                                    @valueChanged="updateValue"
                                    :disabled="true"
                                />
                            </div>
                        </div>
                    </vs-tab>
                </vs-tabs>

                <div>
                    <div class="align-div-preordersummary">
                        <div class="order-infos-div">
                            <div v-if="dataOfProductsToPreOrder.delivery && dataOfProductsToPreOrder.delivery.typeOfDelivery == 'delivery'">
                                <span style="width: 100% !important; padding-right: 2px;">
                                    <!--<<feather-icon
                                        style="float: right !important;"
                                        icon="EditIcon"
                                        svgClasses="w-5 h-5 hover:text-primary stroke-current"  
                                    />-->
                                </span>
                                <img :src="orderDelivery()" alt="Foto do Entregador">
                                <span> Entregador </span>
                            </div>
                            <div v-else-if="dataOfProductsToPreOrder.delivery && dataOfProductsToPreOrder.delivery.typeOfDelivery == 'not_delivery'">
                                <span style="width: 100% !important; padding-right: 2px;">
                                    <!--<<feather-icon
                                        style="float: right !important;"
                                        icon="EditIcon"
                                        svgClasses="w-5 h-5 hover:text-primary stroke-current"  
                                    />-->
                                </span>
                                <vs-icon icon="store" size="40px"/>
                                <span> Retirada </span>
                            </div>

                            <div v-if="dataOfProductsToPreOrder.payment.type != 'none'">
                                <span style="width: 100% !important; padding-right: 2px;">
                                    <!--<<feather-icon
                                        icon="EditIcon"
                                        svgClasses="w-5 h-5 hover:text-primary stroke-current"  
                                        style="float: right !important;"
                                    />-->
                                </span>
                                <img v-if="dataOfProductsToPreOrder.payment.type == 'card'" src="@/assets/images/payment/card.png" alt="Imagem Cartão" id="cardResize"/>
                                <img v-else-if="dataOfProductsToPreOrder.payment.type == 'pix'" src="@/assets/images/payment/pix.png" alt="Imagem Pix" id="pixResize"/>
                                <img v-else-if="dataOfProductsToPreOrder.payment.type == 'cash'" src="@/assets/images/payment/cash.png" alt="Imagem Dinheiro" id="cashResize"/>
                                <span v-if="dataOfProductsToPreOrder.payment.type == 'card'" style="border-radius: 0 !important;"> Cartão </span>
                                <span class="mt-2" v-else-if="dataOfProductsToPreOrder.payment.type == 'pix'"> Pix </span>
                                <span class="mt-2" v-else-if="dataOfProductsToPreOrder.payment.type == 'cash'"> Dinheiro </span>
                            </div>
                            <div v-if="dataOfProductsToPreOrder.delivery && dataOfProductsToPreOrder.delivery.typeOfDelivery == 'delivery'">
                                <span style="width: 100% !important; padding-right: 2px;">
                                    <!--<<feather-icon
                                        style="float: right !important;"
                                        icon="EditIcon"
                                        svgClasses="w-5 h-5 hover:text-primary stroke-current"  
                                    />-->
                                </span>
                                <vs-icon icon="motorcycle" size="medium"/>
                                <span> Entrega </span>
                            </div>
                        </div>
            
                        <div v-if="dataOfProductsToPreOrder.delivery">
                            <span v-if="dataOfProductsToPreOrder.delivery && dataOfProductsToPreOrder.delivery.typeOfDelivery == 'delivery'"> Entrega R$ {{ String(parseFloat(dataOfProductsToPreOrder.delivery.delivery_fee).toFixed(2)).replace('.', ',') }} </span>
                            <h4 class="mt-2" v-if="dataOfProductsToPreOrder.product && !hasService"> Total R$ {{ (String(totalWithDeliveryFee(dataOfProductsToPreOrder.delivery.delivery_fee).toFixed(2)).replace('.', ',') || "") }} </h4>
                            <h4 class="mt-2" v-else-if="dataOfProductsToPreOrder.product && hasService"> Total R$ {{ String(totalProductWithService()).replace('.', ',') }} </h4>
                            <h4 class="mt-2" v-else-if="!dataOfProductsToPreOrder.product && hasService"> Total R$ {{ String(totalOfServices()).replace('.', ',') }} </h4>
                        </div>
                    </div>
    
                    <div class="ajuste-tamanho-vstd-preorders">
                        <div class="mb-5 mt-3 flex">
                            <vs-button 
                                size="small" 
                                @click="$emit('editProductsPreOrder')"
                                class="mb-2 mr-4"
                            >
                                <span class="pr-1" style="font-size: 12px;">
                                    Adicionar Produtos
                                </span>
                                
                            </vs-button>

                            <vs-button 
                                size="small" 
                                @click="lastTab.value ? openModalOrFinish() : nextTab(lastTab.step)" 
                                class="mb-2"
                            >
                                <span style="font-size: 12px;">
                                    {{ lastTab.value ? 'Finalizar' : 'Próximo' }}
                                </span>
                                <vs-icon icon="keyboard_arrow_right" size="35px"/>
                            </vs-button>
                        </div>
                    </div>
                </div>
            </div>

            <vs-popup title="Enviar Orçamento ao Cliente:"
                id="popToSendSummaryToCustomer"
                :active.sync="isActiveSentPreOrderSummary"
                @close="$emit('falseSentPreOrderSummary')"
                > 
                <p> Ao clicar em "Enviar", um resumo desse Orçamento será disparado para o cliente.</p>
                <p>
                    Os dados do pedido serão montados em formado de lista e irão por escrito para a caixa de texto
                    dentro do chat, ficando a critério do atendente revisar e editar essa mensagem caso necessário antes do envio!
                </p> <br>
                <div class="w-full d-flex justify-content-flex-end">
                <vs-button color="danger" @click.stop="prepareData(false)">Não Enviar</vs-button>
                <vs-button class="ml-2" color="success" @click.stop="prepareData(true)">Enviar</vs-button>
                </div>
            </vs-popup>
        </vs-popup>
    </div>
</template>

<script>
    import orderHttp from "@/http/requests/orders";
    import moduleOrder from "@/store/order/moduleOrder";
    import { hasFeature } from "@/utils";
    import axios from 'axios'
    import customerKnowApi    from '@/http/requests/knowledge';

    import flatPickr from 'vue-flatpickr-component';
    import 'quill/dist/quill.core.css';
    import 'quill/dist/quill.snow.css';
    import 'quill/dist/quill.bubble.css';
    import 'flatpickr/dist/flatpickr.css';

    import IntField        from '@/views/reason-response-fields/Int'
    import TextField       from '@/views/reason-response-fields/Text'
    import RadioField      from '@/views/reason-response-fields/Radio'
    import SelectField     from '@/views/reason-response-fields/Select'
    import BooleanField    from '@/views/reason-response-fields/Boolean'
    import DecimalField    from '@/views/reason-response-fields/Decimal'
    import CurrencyField   from '@/views/reason-response-fields/Currency'
    import CheckboxField   from '@/views/reason-response-fields/Checkbox'

    export default {
        name: 'PreOrderSummaryPopUp',
        components: {
            flatPickr,
            IntField,
            TextField,
            RadioField,
            SelectField,
            BooleanField,
            DecimalField,
            CurrencyField,
            CheckboxField
        },
        data() {
            return {
                hasErpFeature: false,
                orderBy: 'ASC',
                sortName: 'name',
                selectedTab: 0,
                componentKey: 0,
                configDatePicker: {
                    enableTime: false,
                    noCalendar: false,
                    time_24hr: true,
                    dateFormat: 'd/m/Y',
                    minDate: new Date()
                },
                configdateTimePicker: {
                    enableTime: true,
                    noCalendar: true,
                    time_24hr: true
                },
                serviceDates: [],
                serviceTimes: [],
                hasServicesFeature: false,
                responses: [],
                options: [],
                customerKnow: {},
                observation: null,
                isServiceActive: false
            }
        },
        emits: [
            'isActiveFalse',
            'backToPayment'
        ],
        computed: {
            hasService() {
                return this.services.length !== 0;
            },
            files() {
                return this.dataOfProductsToPreOrder.files || []
            },
            lastTab() {
                const know = this.currentKnow ? Object.entries(this.currentKnow).length !== 0 : false

                if (this.selectedTab === 0 && this.hasService) {
                    return {value:false, step: 1}
                }

                else if(
                    this.selectedTab === 0 
                    && ( this.files.length > 0
                    || this.dataOfProductsToPreOrder.note)
                ) 
                {
                    return {value: false, step: 2}
                }

                else if(this.selectedTab === 0 && know) {
                    return {value: false, step: 3}
                }

                else if(
                    this.selectedTab === 1
                    && (this.files.length > 0
                    || this.dataOfProductsToPreOrder.note)
                ) {
                    return {value: false, step: 1}
                }

                else if (this.selectedTab === 1 && know) {
                    return {value: false, step: 2}
                }

                else if(this.selectedTab === 2 && know) {
                    return {value: false, step: 1}
                }

                return {value: true, step: 0};
            },
            activeUser() {
                return this.$store.state.AppActiveUser;
            },
            enableNegativeStock() {
                return !!Number(this.$store.state.settings.settings.enable_negative_stock);
            },
        },
        watch: {
            isActive(val) {
                if (val) {
                    this.responses    = []
                    this.options      = []
                    this.customerKnow = {};
                    this.observation  = null;

                    if (this.currentKnow && this.currentKnow.reason_options) {
                        this.fetchCustomerKnow();
                    }

                    this.$forceUpdate();
                    this.componentKey++;

                    if (!this.dataOfProductsToPreOrder.product) {
                        setTimeout(() => {
                            this.selectedTab = this.selectedTab + 1
                            this.$refs.tabOfPreOrderSummary.value = this.selectedTab;
                            this.$refs.tabOfPreOrderSummary.$data.childActive = this.selectedTab;
                        }, 200);
                    }

                    if (this.dataOfProductsToPreOrder.delivery && this.dataOfProductsToPreOrder.delivery.delivery_fee === undefined) {
                        this.dataOfProductsToPreOrder.delivery.delivery_fee = 0
                    }
                }

                if (!val) {
                    [this.serviceDates, this.serviceTimes, this.services] = [[], [], []];
                }
            }
        },
        props: {
            isActive: {
                type: Boolean,
                required: true
            },
            isActiveSentPreOrderSummary: {
                type: Boolean,
                required: true,
                default: false
            },
            chatContact: {
                type: Array|Object,
                required: true
            },
            dataOfProductsToPreOrder: {
                type: Array|Object,
                required: true
            },
            chatTicket: {
                type: Array|Object,
                required: true
            },
            services: {
                type: Object|Array,
                required: true
            },
            outOfChat: {
                type: Boolean,
                default: false
            },
            currentKnow: {
                type: Object,
                required: false
            },
        },
        async mounted() {
          this.hasErpFeature = await hasFeature('erps');
          this.hasServicesFeature = await hasFeature('services');
        },
        created(){
            if(this.services){
                this.isServiceActive = true
            }
        },
        methods: {
            alertQty() {
                let color = `#fc9e46`
                this.$vs.notify({
                  title:'Aviso!',
                  text:'Devido à falta de estoque, este produto não está disponível para venda no momento.',
                  color:color,
                  position:'bottom-left'
                })
            },
            closePopUp() {
                this.isActive = false;
                this.$emit('isActiveFalse');
            },
            orderDelivery() {
                return this.$store.state.AppActiveUser.image;
            },
            totalWithDeliveryFee(delivery_fee = "0.0") {
                let total = 0;
                this.dataOfProductsToPreOrder.product.forEach(item => {
                    if (!this.enableNegativeStock && item.integration_id !== null && item.amount <= 0 && this.hasErpFeature) {
                        item.quantity = 0;
                    }
                    total += (item.discount_price * item.quantity);
                });
                return Number(total.toFixed(2)) + Number(Number(delivery_fee).toFixed(2));
            },
            totalOfServices() {
                let sumOfServices = 0.0;
                if(this.isServiceActive){
                    this.services.forEach(item => {
                    const discountPriceNumeric = parseFloat(item.discount_price);

                    if (!isNaN(discountPriceNumeric)) {
                        sumOfServices += discountPriceNumeric;
                    }
                 });
                 return Number(sumOfServices.toFixed(2));
                }else{
                    this.services.forEach(item => sumOfServices += item.price);

                    return Number(sumOfServices.toFixed(2));
                }
            },
            totalProductWithService() {
                let total = this.totalWithDeliveryFee(this.dataOfProductsToPreOrder.delivery.delivery_fee) + this.totalOfServices();

                return Number(total.toFixed(2));
            },
            prepareData(sendPreOrderToCustomer) {
                this.$emit('falseSentPreOrderSummary');

                let dataToSend = this.dataOfProductsToPreOrder;
                const data = {
                    chat_ticket_id: this.chatTicket.id,
                    customer_id: this.chatTicket.customer ? this.chatTicket.customer.id : undefined,
                    is_pre_order: true,
                    payment_data: JSON.stringify(this.dataOfProductsToPreOrder.payment),
                    files: this.files.length > 0 ? JSON.stringify(this.files) : null,
                    note: this.dataOfProductsToPreOrder.note ? this.dataOfProductsToPreOrder.note : null,
                    reason_id: this.currentKnow ? this.currentKnow.id : null
                };

                if (this.dataOfProductsToPreOrder.product) {
                    let is_delivery = this.dataOfProductsToPreOrder.delivery.typeOfDelivery === 'delivery' ? true : false;
                    let address = null;

                    if (dataToSend.delivery.typeOfDelivery === 'delivery') {
                        delete(dataToSend.delivery.typeOfDelivery);
                        address = dataToSend.delivery;
                    } 
                    else if (dataToSend.delivery.typeOfDelivery === 'none') {
                        address = { address: 'none' }
                    }

                    Object.assign(data, {
                        is_delivery: is_delivery,
                        address: address === null ? null : JSON.stringify(address),
                        purchase_value: this.dataOfProductsToPreOrder.delivery.delivery_fee === undefined
                            ? this.totalWithDeliveryFee()
                            : Number(this.totalWithDeliveryFee(this.dataOfProductsToPreOrder.delivery.delivery_fee).toFixed(2)),
                        product: JSON.stringify(this.dataOfProductsToPreOrder.product),
                        erp_id: this.dataOfProductsToPreOrder.product.erpId ? this.dataOfProductsToPreOrder.product.erpId : null,
                        user_id: this.dataOfProductsToPreOrder.userId ? this.dataOfProductsToPreOrder.userId : null
                    });
                }

                if (this.hasService) {
                    const dates = (this.serviceDates.filter(Boolean).length);
                    const times = (this.serviceTimes.filter(Boolean).length);

                    if (dates !== this.services.length ||
                        times !== this.services.length
                    ) { return this.$vs.notify({
                            color: 'danger',
                            time: 5000,
                            title: 'Aviso:',
                            text: 'Você deve preencher os campos de Data e Horário de realização do Serviço!'
                        });
                    }

                    const serviceDataArray = this.services.map(
                        (service, index) => {
                            return {
                                id: service.id,
                                scheduled_at: this.serviceDates[index] + ' ' + this.serviceTimes[index],
                                discount_price: service.discount_price
                            };
                        }
                    );

                    Object.assign(data, {
                        service: JSON.stringify(serviceDataArray),
                        currentKnow: this.currentKnow ? JSON.stringify(this.currentKnow) : null
                    });

                    data.purchase_value ? data.purchase_value += this.totalOfServices()
                    : data.purchase_value = this.totalOfServices();
                }

                this.sendData(data, sendPreOrderToCustomer);
            },
            async sendData(data, sendPreOrderToCustomer) {
                
                if (!data.user_id) {
                    data.user_id = this.activeUser.id;
                }

                await orderHttp.createPreOrder(data) 
                .then((response) => {

                    if (sendPreOrderToCustomer) {
                        data.id = response.data.data.createPreOrder.id;
                        let serviceParsed = {};

                        if (this.hasService) {
                            serviceParsed = this.services.map(
                                (service, index) => {
                                    return {
                                        id: service.id,
                                        name: service.name,
                                        price: service.price,
                                        discount_price: service.discount_price,
                                        date: this.serviceDates[index],
                                        time: this.serviceTimes[index]
                                    };
                                }
                            );
                        }

                        Object.assign(data, {
                            hasProduct: this.dataOfProductsToPreOrder.product ? true : false,
                            hasService: this.hasService,
                            service: serviceParsed
                        });

                        this.$events.fire('sendPreOrderSummaryToCustomer', data);
                    }
                    this.$emit('isActiveFalse');
                    
                    if (!this.outOfChat) {
                        this.chatContact.customer.address = data.is_delivery ? data.address : this.chatContact.customer.address;
                    }

                    if (!moduleOrder.isRegistered) {
                        this.$store.registerModule('order', moduleOrder)
                        moduleOrder.isRegistered = true
                    }
                    this.$store.dispatch("order/fetchAllPreOrders", {  
                        sortName: 'chat_tickets.customers.name',
                        type: 'ASC',
                        word: '',
                        page: 1,
                        itemsPerPage: 4
                    });
                    
                    return this.$vs.notify({
                        color: 'success',
                        title: 'Sucesso!',
                        text: 'Orçamento criado com sucesso!'
                    })
                })
                .catch((exception) => {
                    console.log(exception);
                    this.modalToTransformIsActive = false;
                    return this.$vs.notify({
                        color: 'danger',
                        title: 'Ocorreu um erro ao criar novo Orçamento!',
                        text: 'Erro ao criar novo Orçamento, por favor nos contate para corrigir-mos!'
                    });
                });
            },
            sortFilter(value) {
                if (value !== null) {
                    if (value !== this.sortName) {
                        this.sortName = value;
                        this.orderBy = 'ASC';
                    } else if (this.orderBy !== "" && this.orderBy === "ASC") {
                        this.orderBy = 'DESC';
                    } else if (this.sortName === value && this.orderBy === "DESC") {
                        this.sortName = 'name';
                        this.orderBy = 'ASC';
                    }
                
                    if (value === 'price') {
                        if (this.orderBy === 'ASC') {
                            this.dataOfProductsToPreOrder.product = this.dataOfProductsToPreOrder.product.sort(function(a, b) {
                                return parseFloat(a.price) - parseFloat(b.price);
                            });
                        } else {
                            this.dataOfProductsToPreOrder.product = this.dataOfProductsToPreOrder.product.sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
                        }
                    } else if (value === 'quantity') {
                        if (this.orderBy === 'ASC') {
                            this.dataOfProductsToPreOrder.product = this.dataOfProductsToPreOrder.product.sort((a, b) => a[value] - b[value]);
                        } else {
                            this.dataOfProductsToPreOrder.product = this.dataOfProductsToPreOrder.product.sort((a, b) => b[value] - a[value]);
                        }
                    } else {
                        if (this.orderBy === 'ASC') {
                            this.dataOfProductsToPreOrder.product = this.dataOfProductsToPreOrder.product.sort((a, b) => a[value].localeCompare(b[value]));
                        } else {
                            this.dataOfProductsToPreOrder.product = this.dataOfProductsToPreOrder.product.sort((a, b) => b[value].localeCompare(a[value]));
                        }
                    }
                }
            },
            openModalOrFinish() {
                if (this.outOfChat) {
                    this.prepareData(false)
                }
                else {
                    this.$emit('trueSentPreOrderSummary')
                }
            },
            openModalService(value, index) {
                let data = {
                    product: value,
                    index: index
                }
                this.$emit('openDiscountServiceModal', data);
            },
            nextTab(step) {

                if (!this.dataOfProductsToPreOrder.product && this.selectedTab === 0) {
                    setTimeout(() => {
                        this.selectedTab = this.selectedTab + 1
                        this.$refs.tabOfPreOrderSummary.value = this.selectedTab ;
                        this.$refs.tabOfPreOrderSummary.$data.childActive = this.selectedTab ;
                    }, 200);
                }

                if (this.hasService && this.selectedTab !== 0) {
                    const dates = (this.serviceDates.filter(Boolean).length);
                    const times = (this.serviceTimes.filter(Boolean).length);

                    if (dates !== this.services.length ||
                        times !== this.services.length
                    ) { return this.$vs.notify({
                            color: 'danger',
                            time: 5000,
                            title: 'Aviso:',
                            text: 'Você deve preencher os campos de Data e Horário de realização do Serviço!'
                        });
                    }
                }

                setTimeout(() => {
                    this.selectedTab = this.selectedTab + step
                    this.$refs.tabOfPreOrderSummary.value = this.selectedTab ;
                    this.$refs.tabOfPreOrderSummary.$data.childActive = this.selectedTab ;
                }, 200);
            },
            resetOptions() {
                this.currentKnow.reason_options.forEach((opt, idx) => {
                let defaultValue = null

                if (opt.reason_option_kind.tag === 'text') {
                    this.options.push(TextField)
                }

                if (opt.reason_option_kind.tag === 'int') {
                    this.options.push(IntField)
                    defaultValue = "0"
                }

                if (opt.reason_option_kind.tag === 'currency') {
                    this.options.push(CurrencyField)
                    defaultValue = "0"
                }

                if (opt.reason_option_kind.tag === 'decimal') {
                    this.options.push(DecimalField)
                defaultValue = "0"
                }

                if (opt.reason_option_kind.tag === 'select') {
                    this.options.push(SelectField)
                }

                if (opt.reason_option_kind.tag === 'radio') {
                    this.options.push(RadioField)
                    defaultValue = "false"
                }

                if (opt.reason_option_kind.tag === 'checkbox') {
                this.options.push(CheckboxField)
                    defaultValue = "false"
                }

                if (opt.reason_option_kind.tag === 'boolean') {
                    this.options.push(BooleanField)
                    defaultValue = "false"
                }

                let items = [null]
                if (opt.reason_option_items && opt.reason_option_items.length > 0) {
                    items = opt.reason_option_items
                }

                items.forEach((item) => {
                    let itemId = null
                    let itemDescription = null
                    this.responses[idx] = this.responses[idx] ? this.responses[idx] : []

                    if (item) {
                        itemId = item.id
                        itemDescription = item.description
                    }

                    this.responses[idx].push({
                        reason_option_is_required: opt.is_required,
                        reason_option_item_id: itemId,
                        description: itemDescription,
                        reason_option_id: opt.id,
                        value: defaultValue
                        })
                    })
                })
            },
            loadOptionsKnow(observation, knowOption){
                let currentOptions = this.currentKnow.reason_options
                if (!currentOptions) { return; }
                
                this.observation = !observation.includes('null') ? observation : null
                
                knowOption.forEach((option) => {
                    let knowOptionIndex = currentOptions.findIndex((e) => { return e.id == parseInt(option.id) })

                    if ( knowOptionIndex === -1 ){ return; }

                    let knowItemIndex = currentOptions[knowOptionIndex].reason_option_items.findIndex((e) => { return e.id == parseInt(option.option_item_id) })
                    knowItemIndex     = knowItemIndex !== -1 ? knowItemIndex : 0

                    if ( option.type === "select" || option.type === "radio" ){

                        this.updateValue(knowOptionIndex, knowItemIndex, true)
                    } else {
                        this.updateValue(knowOptionIndex, knowItemIndex, option.value)
                    }

                    if (option.type === "checkbox") {
                        option.value.split(',').forEach((value) => {
                            knowItemIndex = currentOptions[knowOptionIndex].reason_option_items.findIndex((e) => { return e.description == value })
                            if ( knowItemIndex !== -1 ) { this.updateValue(knowOptionIndex, knowItemIndex, true) }
                        })
                    }
                })
            },
            fetchCustomerKnow() {
                if ( !this.currentKnow ){ return }

                const customerId = this.chatContact ? this.chatContact.customer.id : this.chatTicket.customer.id
                customerKnowApi.fetch(customerId, this.currentKnow.id)
                .then((response) => {
                    this.customerKnow = response.data.data.customerKnowledge[0]
                    this.prepareOptionsKnow()
                })
                .catch((error) => { console.error(error) })
            },
            prepareOptionsKnow(){
                if( !this.customerKnow ){ return this.resetOptions(); }


                let observation     = this.customerKnow.observation
                let knowOption      = this.customerKnow.reason_option

                this.resetOptions();
                this.loadOptionsKnow(observation, knowOption)
            },
            updateValue(index, itemIndex, value) {
                let opts = {
                    reason_option_is_required: this.responses[index][itemIndex].reason_option_is_required,
                    reason_option_item_id: this.responses[index][itemIndex].reason_option_item_id,
                    reason_option_id: this.responses[index][itemIndex].reason_option_id,
                    description: this.responses[index][itemIndex].description,
                    value: value.toString()
                }

                let list = this.responses[index]
                list.splice(itemIndex, 1, opts)
                this.responses.splice(index, 1, list)
            },
            removeProduct(index) {
                this.dataOfProductsToPreOrder.product.splice(index, 1);
            }
        }
    }
</script>

<style lang="scss">
    #popUpPreOrderSummaryChat div.vs-popup {
        .vs-popup--content {
            padding: 15px;
            margin: 0;
        }
        margin: 0;
        border-radius: 18px !important;
        border: solid 1.2px;
        border-color: rgba(18, 17, 17, 0.769);
        width: 750px !important;
        .vs-popup--header {
            background-color: transparent !important;
            .vs-popup--title {
                background-color: transparent !important;
                h3 {
                    background-color: transparent !important;
                }
            }
        }
        header {
            background-color: transparent !important;
        }
        .ajuste-tamanho-vstd-preorders {
            float: right;
            padding-right: 10px;
            width: 160px;
            border-width: 1px 0px 1px 0px; 
            div {
                float: right;
                button {
                    display: flex;
                    border-radius: 15px;
                    height: 35px;
                    padding: 0px 16px 0px 25px;
                    justify-content: center;
                }
                span.vs-button-text.vs-button--text {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                }
            }
        }

        div.align-div-preordersummary {
            display: flex;
            justify-content: space-between;
            margin-left: 14px;
            margin-right: 14px;
    
            .order-infos-div {
                display: flex;
                div {
                    border: solid 2px #abb3b257; 
                    border-radius: 14px;
                    cursor: pointer;
                    margin: 8px;
                    margin-left: 0;
                    width: 90px;
                    height: 80px;
                    display: flex;
                    flex-direction: column;
                    align-content: center;
                    justify-content: center;
                    align-items: center;
                    flex-wrap: wrap;
            
                    span {
                        font-size: 10px;
                        text-align: center;
                    }
                    img {
                        width: 36px;
                        height: 36px;
                        border-radius: 40px;
                    }
                }
            }
        }

        #tableProductPreOrdersSummaryChat {
            .vs-con-tbody.vs-table--tbody {
                background-color: transparent !important;
                border: 0 !important; 
            }
            table.vs-table.vs-table--tbody-table {
                border-collapse: separate;
                border-spacing: 0 0.5rem;
                padding: 0 1rem;
            }
            tbody {  
                tr {
                    .d-flex.flex-row.items-center {
                        display: flex; 
                        justify-content: space-evenly;
                    }
                    td {
                        padding: 0px;
                        border-style: solid; 
                        border-color: #b6bebd6e;
                        height: 4em;
                    }
                    td:first-of-type {
                        border-top-left-radius: 18px !important; 
                        border-bottom-left-radius: 18px !important; 
                        border-width: 1px 0px 1px 1px;
                    }
                    td:nth-of-type(2), td:nth-of-type(3), td:nth-of-type(4), td:nth-of-type(5) {
                        border-width: 1px 0px 1px 0px; 
                    }
                    td:last-of-type {
                        border-width: 1px 1px 1px 0px;
                        border-top-right-radius: 18px !important;
                        border-bottom-right-radius: 18px !important;
                        padding-right: 10px;
                    }
                }
            }
        }
        #tableServicePreOrdersSummaryChat {
            .vs-con-tbody.vs-table--tbody {
                background-color: transparent !important;
                border: 0 !important; 
            }
            table.vs-table.vs-table--tbody-table {
                border-collapse: separate;
                border-spacing: 0 0.5rem;
                padding: 0 1rem;
            }
            tbody {  
                tr {
                    .d-flex.flex-row.items-center {
                        display: flex; 
                        justify-content: space-evenly;
                    }
                    td {
                        padding: 0px;
                        border-style: solid; 
                        border-color: #b6bebd6e;
                        height: 4em;
                    }
                    td:first-of-type {
                        border-top-left-radius: 18px !important; 
                        border-bottom-left-radius: 18px !important; 
                        border-width: 1px 0px 1px 1px;
                    }
                    td:nth-of-type(2), td:nth-of-type(3), td:nth-of-type(4) {
                        border-width: 1px 0px 1px 0px; 
                    }
                    td:last-of-type {
                        border-width: 1px 1px 1px 0px;
                        border-top-right-radius: 18px !important;
                        border-bottom-right-radius: 18px !important;
                        padding-right: 10px;
                    }
                }
            }
        }
        #pixResize {
            width: 60px !important;
            height: 23px !important;
        }
        #cardResize {
            border-radius: 0 !important;
            height: 35px !important;
            width: 50px !important;
        }
        #cashResize {
            width: 40px !important;
            height: 30px !important;
        }
    }
    #popToSendSummaryToCustomer {
        .vs-popup {
            width: 500px !important;
        }
    }
    .align-input-date-time {
        display: flex;
      }
      > div {
        flex: 1;
      }
</style>
